const localeActions = {
    CHANGE_LOCALE: 'CHANGE_LOCALE',

    changeLocale: (lang) => ({
        type: localeActions.CHANGE_LOCALE,
        lang,
    }),
};

export default localeActions; 